module.exports = __webpack_public_path__ + "img/logo.dac85584.jpg";